import { Injectable, Output } from '@angular/core';
import { ConfigDB } from '../data/config';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class SoundService {

  private theme: BehaviorSubject<string>;
  public layoutVersion = ConfigDB.data.settings.layout_version;

  constructor() {
    this.theme = new BehaviorSubject<string>(this.layoutVersion);
  }

  changeAtmosphere(val) {
    this.layoutVersion = val;
    this.theme.next(val);
  }

  getTheme() {
    return this.theme.asObservable();
  }

  turnOnAtmosphere() {
    // let audioBackground = document.getElementById('music-background') as any;
    // audioBackground.play();

  }

  turnOnTeamSound() {
    // let audioTeam = document.getElementById('music-team') as any;
    // let team = document.querySelectorAll("[team-sound='true']");
    // let _this = this;

    // team.forEach(person => {
    //   person.addEventListener("mouseenter", function personSound(event) {
    //     if (_this.layoutVersion == 'dark') {
    //       audioTeam.play();
    //     }
    //     else {
    //       person.removeEventListener("mouseenter", personSound);
    //     }
    //   })
    //   person.addEventListener("mouseleave", function personSound(event) {
    //     if (_this.layoutVersion == 'dark') {
    //       audioTeam.pause();
    //       audioTeam.currentTime = 0;
    //     }
    //     else {
    //       person.removeEventListener("mouseleave", personSound);
    //     }
    //   })
    // })
  }

  turnOnMenuSound() {
    // let audioMenuItems = document.getElementById('music-menu') as any;
    // let menuItems = document.querySelectorAll("[menu-sound='true']");
    // let _this = this;
    // menuItems.forEach(link => {
    //   link.addEventListener("mouseenter", function link-sound(event) {
    //     if (_this.layoutVersion == 'dark') {
    //       audioMenuItems.play();
    //     }
    //     else {
    //       link.removeEventListener("mouseenter", link-sound);
    //     }
    //   })
    //   link.addEventListener("mouseleave", function link-sound(event) {
    //     if (_this.layoutVersion == 'dark') {
    //       audioMenuItems.pause();
    //       audioMenuItems.currentTime = 0;
    //     }
    //     else {
    //       link.removeEventListener("mouseleave", link-sound);
    //     }
    //   })
    // })
  }

  turnOnIconsSound() {
    // let audioIcons = document.getElementById('music-icons') as any;
    // let iconsItems = document.querySelectorAll("[icons-sound='true']");
    // let _this = this;
    // iconsItems.forEach(link => {
    //   link.addEventListener("mouseenter", function icons-sound(event) {
    //     if (_this.layoutVersion == 'dark') {
    //       audioIcons.play();
    //     }
    //     else {
    //       link.removeEventListener("mouseenter", icons-sound);
    //     }
    //   })
    //   link.addEventListener("mouseleave", function icons-sound(event) {
    //     if (_this.layoutVersion == 'dark') {
    //       audioIcons.pause();
    //       audioIcons.currentTime = 0;
    //     }
    //     else {
    //       link.removeEventListener("mouseleave", icons-sound);
    //     }
    //   })
    // })
  }

  turnOnLinkSound() {
    // let audioLink = document.getElementById('music-links') as any;
    // let links = document.querySelectorAll("[link-sound='true']");

    // let _this = this;

    // links.forEach(link => {
    //   link.addEventListener("mouseenter", function link-sound(event) {
    //     if (_this.layoutVersion == 'dark') {
    //       audioLink.play();
    //     }
    //     else {
    //       link.removeEventListener("mouseenter", link-sound);
    //     }
    //   })
    //   link.addEventListener("mouseleave", function link-sound(event) {
    //     if (_this.layoutVersion == 'dark') {
    //       audioLink.pause();
    //       audioLink.currentTime = 0;
    //     } else {
    //       link.removeEventListener("mouseleave", link-sound);
    //     }
    //   })
    // })
  }

  turnOnButtonSound() {
    // let audioButton = document.getElementById('music-buttons') as any;
    // let buttons = document.querySelectorAll("[button-sound='true']");

    // let _this = this;

    // buttons.forEach(button => {
    //   button.addEventListener("mouseenter", function button-sound(event) {
    //     if (_this.layoutVersion == 'dark') {
    //       audioButton.play();
    //     }
    //     else {
    //       button.removeEventListener("mouseenter", button-sound);
    //     }
    //   })
    //   button.addEventListener("mouseleave", function button-sound(event) {
    //     if (_this.layoutVersion == 'dark') {
    //       audioButton.pause();
    //       audioButton.currentTime = 0;
    //     } else {
    //       button.removeEventListener("mouseleave", button-sound);
    //     }
    //   })
    // })
  }

  turnServiceSound() {
    // let audioService = document.getElementById('music-services') as any;
    // let serviceItems = document.querySelectorAll("[service-sound='true']");
    // let _this = this;
    // serviceItems.forEach(service => {
    //   service.addEventListener("mouseenter", function service-sound(event) {
    //     if (_this.layoutVersion == 'dark') {
    //       audioService.play();
    //     }
    //     else {
    //       service.removeEventListener("mouseenter", service-sound);
    //     }
    //   })
    //   service.addEventListener("mouseleave", function service-sound(event) {
    //     if (_this.layoutVersion == 'dark') {
    //       audioService.pause();
    //       audioService.currentTime = 0;
    //     } else {
    //       service.removeEventListener("mouseleave", service-sound);
    //     }
    //   })
    // })
  }

  turnOffAtmosphere() {
    // let audios = document.getElementsByTagName('audio') as any;

    // for (let audio of audios) {
    //   audio.pause();
    //   audio.currentTime = 0;
    // }
  }
}
